import {
	BifrostBackendNestApi
} from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";
import { store } from "../store";

export const MYSTERY_BOX_VOUCHER_STATUSES = Object.freeze({
	CANCEL: "cancel",
	CONFIRM: "confirm"
});

const MysteryBoxProvider = {
	getMysteryBoxData({email, mysteryBoxProducts, voucherId, shopId, shopTimeZone}) {
		return BifrostBackendNestApi.post(`/mystery-box?filter=customerEmail:eq:${encodeURIComponent(email)}`, {
			params: {
				tenantId: appConfig.tenantId
			},
			voucherId,
			mysteryBoxProducts,
			shopId,
			shopTimeZone,
			channel: appConfig.channelAlias(),
			deliveryMethod: store.getters.tenantSpecificData && store.getters.tenantSpecificData.deliveryChoice
		},
		{
			headers: {
				Authorizationidp: store.getters.applicationUserIdpToken
			}
		});
	},

	changeStatusMysteryBox(voucherVirtualOrderId, status = MYSTERY_BOX_VOUCHER_STATUSES.CANCEL) {
		return BifrostBackendNestApi.patch(`/mystery-box/${voucherVirtualOrderId}`, {status});
	}

};

export default Object.freeze(MysteryBoxProvider);
